import React, { useState, PropsWithChildren } from 'react';
import { useMutation } from '@apollo/client/react/hooks';
import DeleteIcon from '@mui/icons-material/Delete';
import { gql } from '@yi/core';
import { i18n_remove } from '@yi/i18n/phrases/i18n_remove';

import { notifyBugsnag } from '~/common';

import { StyledMenuItem, StyledSmallSpinner } from './elements';
import { useLocale } from '../LocaleProvider';

interface Props {
  item: {
    id: string;
    contentId: string;
    type: gql.typesClient.LogConsumptionTrackingType;
  };
  callback?: () => void;
  onRemove?: (activityId: string) => void;
}

export const RemoveHistory: React.FC<PropsWithChildren<Props>> = ({ item, callback, onRemove }) => {
  const { locale } = useLocale();

  const [logConsumptionTracking, logConsumptionTrackingResult] = useMutation<
    gql.typesClient.Mutate_LogConsumptionTracking_Base,
    gql.typesClient.Mutate_LogConsumptionTracking_BaseVariables
  >(gql.Mutate_LogConsumptionTracking_Base, {
    // If graphQL error, onError is necessary for mutation promise to resolve
    onError: error => {
      if (callback) callback();
      notifyBugsnag(error);
      console.warn(error);
    },
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <StyledMenuItem
      style={{ minWidth: '132px', gap: '5px' }}
      onClick={async e => {
        e.preventDefault();
        if (!isSubmitting) {
          setIsSubmitting(true);
          await logConsumptionTracking({
            variables: {
              row_id: item.id,
              class_id: item.contentId,
              duration: 0,
              minutes: 0,
              type: item.type,
            },
          }).then(result => {
            if (result.data?.logConsumptionTracking.status && typeof onRemove === 'function') {
              onRemove(item.id);
            }
          });
          setIsSubmitting(false);
          if (callback) callback();
        }
      }}
    >
      <DeleteIcon opacity="0.7" />
      {i18n_remove(locale)}
      {logConsumptionTrackingResult.loading && <StyledSmallSpinner size="18px" />}
    </StyledMenuItem>
  );
};
